import React from 'react';
import { ZitoneoPreviewServiceCategoryState } from '../../../types/zitoneoPreviewTypes';
import { Icon } from '@iconify/react';
import ServiceSection from './ServiceSection';

interface CategorySectionProps {
    category: ZitoneoPreviewServiceCategoryState;
    scope?: 'hotel' | 'room';
}

/**
 * Displays a service category with a hierarchy matching its content scope.
 * @param props - Adapted category and optional hotel or room scope.
 * @returns The category heading and its service list.
 */
const CategorySection = ({
    category,
    scope = 'hotel',
}: CategorySectionProps) => {
    const Heading = scope === 'room' ? 'h4' : 'h5';
    return (
        <section
            className={`service-section${
                scope === 'room' ? ' service-section--room' : ''
            }`}
        >
            <header className='service-section-web__header'>
                <div className='service-section__header-main'>
                    <div className='service-section__header-icon-container'>
                        <Icon
                            icon={category.Icon}
                            className='service-section__header-icon'
                        />
                    </div>
                    <Heading className='service-section__header__title'>
                        {category.Name}
                    </Heading>
                    <p className='service-section__header__count'>
                        {category.ServiceCount}
                    </p>
                </div>
                {category.Description ? (
                    <p className='service-section__header__description'>
                        {category.Description}
                    </p>
                ) : null}
            </header>
            <ul className='service-section__content'>
                {category.Services.map((service, index) => {
                    const sameTypeBefore = category.Services.slice(
                        0,
                        index
                    ).filter(
                        s => s.IdServiceType === service.IdServiceType
                    ).length;
                    const sameTypeCount = category.Services.filter(
                        s => s.IdServiceType === service.IdServiceType
                    ).length;
                    const shouldShowIndex = sameTypeCount > 1 && !service.Name;

                    return (
                        <ServiceSection
                            service={service}
                            scope={scope}
                            index={
                                shouldShowIndex ? sameTypeBefore + 1 : undefined
                            }
                            key={service.Id}
                        />
                    );
                })}
            </ul>
        </section>
    );
};

export default CategorySection;
